import React, { useState } from "react";
import ImportIcon from "../../../assets/icons/import-01.svg2";
import MyIcon from "../MyIcon";
import { Button, Modal } from "react-bootstrap";
import WhiteButton from "../WhiteButton";
import ProgressBar from "react-bootstrap/ProgressBar";

export default function DataImportProgressModal() {
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [show, setShow] = useState(false);
  const now = 60;

  return (
    <>
      <WhiteButton
        as="button"
        icon={ImportIcon}
        heading="Data Import Progress Button"
        subheading="Data"
        disabled={false}
        onClick={handleShow}
      />
      <Modal show={show} onHide={handleClose} size="lg" className="m-5">
        <Modal.Header className="bg-colored-reverse p-3 rounded-top-3" closeButton>
          <Modal.Title className="text-white">
            <ImportIcon width={20} className="text-white ms-2" />
            <span className="ms-3 fw-bold">Data importer</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark opacity-75 align-items-center rounded-bottom-3">
          <div className="d-flex flex-column align-items-center p-5">
            <ImportIcon width={40} />
            <div className="fw-bold fs-4 text-white py-3">
              Data Import Progress
            </div>
            <div className="w-100">
              <ProgressBar variant="colored" now={now} />
            </div>
            <div className="d-flex py-3">
              <div className="fw-bold text-secondary">Estimated Time:</div>
              <div className="text-secondary">1:25 minutes left</div>
            </div>

            <div className="d-flex flex-column my-5 align-items-center">
              <Button
                type="submit"
                className="btn btn-colored-reverse rounded-pill fw-bold px-4 border-0 "
                onClick={handleClose}
              >
                MINIMISE
              </Button>
              <div className="text-secondary py-3">
                Your data will still import in the background
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
